import Dater from '../../../services/DateFormat'
const FormatPostagens = postagens => {
  const result = postagens.map(item => ({
    id: item.id,
    livro: item.obra.titulo,
    data: Dater().formatar(item.created_at, 'dd/mm/yyyy hours:mins'),
    postagem: item.resumo !== null ? 'escrita' : 'video',
    paginas: item.obra.numero_pagina,
    periodo: Dater().adicionarZero(item.mes_id) + '/' + item.ano_id,
    mes: item.mes_id,
    ano: item.ano_id,
    leitor: item.leitor.user.name,
    statusRh: item.status_postagem_id,
    conteudoAplicadoVida: item.conteudo_aplicado_vida,
    pathVideo: item.video_path,
    resumo: item.resumo,
    biblioteca: item.leitor.biblioteca.apelido
  }))
  return result
}

export default FormatPostagens
